import React, { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import RequireUser from "@/components/public/RequireUser";
import { usePaymentPolling } from "@/components/tournament/CheckoutModal";

function Inner() {
  const [params] = useSearchParams();
  const [info, setInfo] = useState(null);
  const state = usePaymentPolling(params.get("session_id"), setInfo);
  return (
    <div className="py-24 text-center max-w-md mx-auto px-4" data-testid="payment-return">
      {state === "paid" ? <CheckCircle2 size={48} className="mx-auto text-green-400" /> : ["failed", "timeout"].includes(state) ? <XCircle size={48} className="mx-auto text-red-400" /> : <Loader2 size={40} className="mx-auto animate-spin text-white/50" />}
      <h1 className="mt-5 text-2xl font-bold text-white" data-testid="payment-return-status">
        {state === "paid" ? "Payment successful" : state === "failed" ? "Payment failed" : state === "timeout" ? "Still processing" : "Confirming your payment…"}
      </h1>
      <p className="mt-2 text-white/50">{state === "paid" ? "Your tournament is now public." : state === "timeout" ? "Check your profile in a minute." : ""}</p>
      <div className="mt-8 flex justify-center gap-3">
        {info?.tournament && <Link to={`/profile/tournaments/${info.tournament.id}`} className="px-5 py-2.5 rounded-full bg-[hsl(var(--primary))] text-white font-bold" data-testid="payment-manage-link">Manage tournament</Link>}
        <Link to="/profile" className="px-5 py-2.5 rounded-full border border-white/20 text-white font-bold">My Profile</Link>
      </div>
    </div>
  );
}

export default function PaymentReturn() {
  return <RequireUser><Inner /></RequireUser>;
}
